import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      '& > span': {
        paddingRight: theme.spacing(1.5),
      },
    },
    menuPaper: {
      width: 248,
      marginTop: theme.spacing(0.5),
      border: 'none',
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      columnGap: theme.spacing(1.5),
      padding: theme.spacing(1.5, 1),
      minHeight: 60,
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: theme.spacing(0.5),
    },
    subtitle: {
      color: COLORS.gray.gray40,
      maxWidth: 216,
    },
  }),
  { name: 'CreateContentItem' }
);
